import React, { Component, Fragment } from "react";
import AppContext from "../../../contexts/AppContext";
import Invoice from "../../payment/Invoice";

class List extends Component {
    state = {
        delete: false,
        update: false,
        invoice: false,
        item: {}
    };
    renderReport = () => {
        switch (this.context.state.reportName) {
            case "report:Invoice":
                return <Invoice></Invoice>;
                // eslint-disable-next-line
                break;
            default:
                break;
        }
    };

    /* delete */
    delete = () => {
        return this.props.delete(this.props.item.id);
    };
    toggleDelete = () => {
        this.setState({ delete: this.state.delete === true ? false : true });
    };

    /* update */
    toggleUpdate = () => {
        this.state.update === true
            ? this.setState({ update: false })
            : this.props
                  .getItem(this.props.item.id)
                  .then(response => {
                      this.setState({ update: true, item: response.data });
                  })
                  .catch(error => {
                      this.context.state.handelError(error);
                  });
    };

    render() {
        return (
           
            <Fragment>
                <tr>
				    {/*<td>{this.props.item.id}</td>*/}
                    <td className="vertical-align:center;">{this.props.item.plan !== null ? this.props.item.plan.name : this.props.item.user.plan.name}</td>
                    <td className="vertical-align:center;">${this.props.item.total}</td>
                    <td className="vertical-align:center;">
                        <div className="row align-items-center">
                            {/* {this.props.item.card_id === 0 ? null : (
                                <Fragment>
                                    <div className="col-auto">
                                        <img src={`/cards/${this.props.item.card.type.charAt(0).toUpperCase() + this.props.item.card.type.slice(1)}.png`} className="cc-image-lg" alt=""></img>
                                    </div>
                                    <div className="col ml-n2">
                                        <h4 className="mb-1 name">
                                            •••• •••• ••••{" "}
                                            {this.props.item.card.code}
                                        </h4>
                                    </div>
                                </Fragment>
                            )} */}
                              { this.props.item.payment_method === '2' ? "PayPal" :"Stripe"}
                        </div>
                    </td>
                    <td className="vertical-align:center;">
                        <div className="col ml-n2">
                            <h4 className="mb-1 name">
                                {this.props.item.state}
                            </h4>
                        </div>
                    </td>
                    <td className="vertical-align:center;">
                        <time dateTime={this.props.item.created_at}>
                            {this.props.item.created_at}
                        </time>
                    </td>
                  
                </tr>
                {this.renderReport()}
            </Fragment>
        );
    }
}
List.contextType = AppContext;
export default List;



// WEBPACK FOOTER //
// ./src/components/writer/billing/BillingList.js